import {
  Box,
  Container,
  FormControl,
  Grid,
  InputLabel,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import AddIcon from "@material-ui/icons/Add";

const useStyles = makeStyles({
  quoteHeading: {
    display: "flex",
    justifyContent: "space-between",
    background: "#DEECFC",
    padding: "10px 20px",
    borderRadius: "10px",
    margin: "10px 0",
  },
  quoteContent: {
    padding: "10px 0px",
    borderRadius: "5px",
  },
  title: {
    paddingBottom: "0px",
  },
  requestQuoteTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
  },
  formControl: {
    minWidth: 300,
  },
  selectEmpty: {},
  quoteContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  requestQuote1Submit: {
    width: "160px",
    height: "45px",
    marginInlineEnd: "10px",
    background: "#BE1E2D",
    color: "#fff",
    marginTop: "20px",
    fontWeight: "600",
  },
});

const LoadingAndUnLoading = ({ hanldeIncrementLD }) => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    Food: "",
    fullLoad: "",
    truckType: "",
    make: "",
    lessLoad: "",
    top: "",
    side: "",
    name: "hai",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };
  return (
    <Box className="loadingUnloadingDetalis">
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          columnGap: "10px",
          padding: "15px 10px",
        }}
      >
        <Typography variant="span">
          <HomeIcon />
        </Typography>
        <Typography variant="h6">Loading And UnLoading Details</Typography>
      </Box>
      <Container>
        {" "}
        <Box className="loadingUnloadingHeading">
          <Box className="loadingUnloadingHeading1">
            <Typography variant="span">
              <HomeIcon />
            </Typography>
            <Typography variant="h6">From</Typography>
          </Box>
          <Box className="loadingUnloadingHeading2">
            <Typography variant="h6">To</Typography>
          </Box>
          <Box className="loadingUnloadingHeading3">
            <Typography variant="span">
              <AddIcon onClick={hanldeIncrementLD} />
            </Typography>
          </Box>
        </Box>
      </Container>
      <Container>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={4} md={4}>
            <Typography variant="h6" className="loadingUnloadingTitle">
              Location
            </Typography>
            <Typography variant="h6" className="loadingUnloadingTitle">
              Loading Method
            </Typography>
            <Typography variant="h6" className="loadingUnloadingTitle">
              Equipment Required
            </Typography>
            <Typography variant="h6" className="loadingUnloadingTitle">
              Site Inspection
            </Typography>
            <Typography variant="h6" className="loadingUnloadingTitle">
              Contact Person Name
            </Typography>
            <Typography variant="h6" className="loadingUnloadingTitle">
              Contact Person Phone Number
            </Typography>
          </Grid>
          <Grid item xs={12} lg={4} md={4}>
            <Box className="loadinUnloadingInput">
              <TextField
                id="outlined-basic"
                label="Dubai United Arab Emirates"
                variant="outlined"
              />
            </Box>
            <Box className="loadinUnloadingInput">
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-age-native-simple">
                  Top
                </InputLabel>
                <Select
                  native
                  value={state.top}
                  onChange={handleChange}
                  label="Top"
                  inputProps={{
                    name: "top",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" />
                  <option value={"Top"}>Top</option>
                  <option value={20}>Twenty</option>
                  <option value={30}>Thirty</option>
                </Select>
              </FormControl>
            </Box>
            <Box className="loadinUnloadingInput">
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-age-native-simple">
                  Yes
                </InputLabel>
                <Select
                  native
                  value={state.top}
                  onChange={handleChange}
                  label="Yes"
                  inputProps={{
                    name: "yes",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" />
                  <option value={"Yes"}>Yes</option>
                  <option value={20}>Twenty</option>
                  <option value={30}>Thirty</option>
                </Select>
              </FormControl>
            </Box>
            <Box className="loadinUnloadingInput">
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-age-native-simple">
                  Yes
                </InputLabel>
                <Select
                  native
                  value={state.top}
                  onChange={handleChange}
                  label="Yes"
                  inputProps={{
                    name: "yes",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" />
                  <option value={"Yes"}>Yes</option>
                  <option value={20}>Twenty</option>
                  <option value={30}>Thirty</option>
                </Select>
              </FormControl>
            </Box>
            <Box className="loadinUnloadingInput">
              <TextField
                id="outlined-basic"
                label="John Doe"
                variant="outlined"
              />
            </Box>
            <Box className="loadinUnloadingInput">
              <TextField
                id="outlined-basic"
                label="+971 52438445"
                variant="outlined"
              />
            </Box>
          </Grid>
          <Grid item xs={12} lg={4} md={4}>
            <Box className="loadinUnloadingInput">
              <TextField
                id="outlined-basic"
                label="Riyadh, Saudi"
                variant="outlined"
              />
            </Box>
            <Box className="loadinUnloadingInput">
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-age-native-simple">
                  Side
                </InputLabel>
                <Select
                  native
                  value={state.side}
                  onChange={handleChange}
                  label="Side"
                  inputProps={{
                    name: "side",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" />
                  <option value={"Side"}>Side</option>
                  <option value={20}>Twenty</option>
                  <option value={30}>Thirty</option>
                </Select>
              </FormControl>
            </Box>
            <Box className="loadinUnloadingInput">
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-age-native-simple">No</InputLabel>
                <Select
                  native
                  value={state.top}
                  onChange={handleChange}
                  label="Top"
                  inputProps={{
                    name: "top",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" />
                  <option value={"Top"}>Top</option>
                  <option value={20}>Twenty</option>
                  <option value={30}>Thirty</option>
                </Select>
              </FormControl>
            </Box>
            <Box className="loadinUnloadingInput">
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-age-native-simple">No</InputLabel>
                <Select
                  native
                  value={state.top}
                  onChange={handleChange}
                  label="no"
                  inputProps={{
                    name: "top",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" />
                  <option value={"Top"}>No</option>
                  <option value={20}>Twenty</option>
                  <option value={30}>Thirty</option>
                </Select>
              </FormControl>
            </Box>
            <Box className="loadinUnloadingInput">
              <TextField
                id="outlined-basic"
                label="John Doe"
                variant="outlined"
              />
            </Box>
            <Box className="loadinUnloadingInput">
              <TextField
                id="outlined-basic"
                label="+971 52438445"
                variant="outlined"
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default LoadingAndUnLoading;
